import React from "react";
import { Box } from "@mui/material";
import NavigationLink from "./NavigationLink";
import NavigationDropDown from "./NavigationDropDown";
import { useSelector } from "react-redux";
import { darkTheme, lightTheme } from "../../../theme/Theme";
const NavigationBar = () => {
  const isDarkTheme = useSelector((state) => state.theme);
  const { navigations } = useSelector((state) => state.nav);

  // Filter out empty page groups (INTERNAL_GROUP with no children)
  const filteredNavigations = navigations?.filter((nav) => {
    if (nav?.type === "INTERNAL_GROUP") {
      // Hide page groups that have no children or empty children array
      return nav?.children && nav.children.length > 0;
    }
    return true; // Keep all non-page-group items
  });

  return (
    <Box
      sx={{
        display: { xs: "none", md: "none", lg: "flex" },
        padding: "8px 24px",
        alignItems: "center",
        gap: "24px",
        alignSelf: "stretch",

        background: isDarkTheme
          ? darkTheme.backgroundColorLayer3
          : lightTheme.backgroundColorLayer3,
      }}
    >
      <Box
        sx={{ display: "flex", gap: 2, fontSize: "14px", color: "#616161" }}
        data-testid="test-navigations"
      >
        {filteredNavigations?.map((nav) =>
          nav?.children ? (
            <NavigationDropDown
              key={nav?.navigationId}
              label={nav?.label}
              menuItems={nav?.children.map((child) => ({
                url: child?.url,
                label: child?.label,
              }))}
            />
          ) : (
            <NavigationLink
              key={nav?.navigationId}
              to={nav?.url}
              label={nav?.label}
            />
          )
        )}
      </Box>
    </Box>
  );
};

export default NavigationBar;
